// ExchangeStageCancelled.jsx
import React, {useMemo} from "react";
import {Alert, Button, Descriptions, Tag, Typography} from "antd";
import {useNavigate} from "react-router-dom";
import StageBar from "./ui/StageBar";

const {Text} = Typography;

function normalizeStatus(s) {
  return String(s || "").toUpperCase();
}

function formatDate(v) {
  if (!v) return "—";
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
}

function formatMoneyLike(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

function statusTag(status) {
  const s = normalizeStatus(status);
  if (s === "CANCELLED" || s === "CANCELED") return <Tag color="red">ОТМЕНЕНА</Tag>;
  return <Tag>{s || "—"}</Tag>;
}

export default function ExchangeStageCancelled({stage, tx, onRestart}) {
  const navigate = useNavigate();

  const summary = useMemo(() => {
    const pair = tx?.pair || null;
    const payout = tx?.payout || null;

    const fromCur = tx?.currency_from || pair?.currency_from || "—";
    const toCur = tx?.currency_to || pair?.currency_to || "—";

    const toMethod = pair?.method_to?.title || pair?.method_to?.code || "—";
    const payoutDetail = payout?.detail || "—";

    return {
      id: tx?.id || "—",
      code: tx?.code || "—",
      status: tx?.status,
      created_at: tx?.created_at || null,
      amount_from: tx?.amount_from,
      amount_to: tx?.amount_to,
      currency_from: fromCur,
      currency_to: toCur,
      payout: `${payoutDetail} (${toMethod})`,
    };
  }, [tx]);

  return (
    <div className="w-full">
      <div className="max-w-[980px] mx-auto">
        <div
          className="bg-white rounded-[18px] border border-black/5 shadow-[0_14px_40px_rgba(16,24,40,0.12)] overflow-hidden">
          <div className="px-6 py-6 max-[520px]:px-4 max-[520px]:py-5" style={{minHeight: 520}}>

            <div className="mb-6">
              <StageBar stage={stage} status={tx?.status}/>
            </div>

            <Alert
              type="error"
              showIcon
              message="Обмен отменён"
              description="Если вы хотите выполнить обмен — создайте новую заявку."
            />

            <div className="mt-6">
              <Descriptions size="small" bordered column={1} labelStyle={{width: 220}}>
                <Descriptions.Item label="ID заявки">{summary.id}</Descriptions.Item>
                <Descriptions.Item label="Код">{summary.code}</Descriptions.Item>
                <Descriptions.Item label="Статус">
                  <div className="flex items-center gap-2">
                    {statusTag(summary.status)}
                    <Text type="secondary">{normalizeStatus(summary.status)}</Text>
                  </div>
                </Descriptions.Item>
                <Descriptions.Item label="Отдаёте">
                  {formatMoneyLike(summary.amount_from)} {summary.currency_from}
                </Descriptions.Item>
                <Descriptions.Item label="Получаете">
                  {formatMoneyLike(summary.amount_to)} {summary.currency_to}
                </Descriptions.Item>
                <Descriptions.Item label="Реквизиты">{summary.payout}</Descriptions.Item>
                <Descriptions.Item label="Создана">{formatDate(summary.created_at)}</Descriptions.Item>
              </Descriptions>
            </div>

            <div className="mt-8 flex flex-wrap gap-10">
              <Button onClick={() => navigate("/exchange/my")}>К моим обменам</Button>
              <Button type="primary" onClick={onRestart}>
                Создать новую заявку
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}